// ABOUTME: Full-screen veil with a spinner shown while a configured item is being saved.
// ABOUTME: Rendered in a portal on body, so a sticky or z-indexed ancestor cannot put it under the page.

import { Box, CircularProgress } from '@ds/coolshop';
import { createPortal } from 'react-dom';

/**
 * Bridges a save's network wait that has no dialog of its own. The widgets that show it sit
 * inside the page layout (e.g. a sticky action bar, which opens its own stacking context), so
 * the veil is portaled to body: there its z-index ranks it above the layout's side panels too.
 */
export function SavingOverlay() {
    return createPortal(
        <Box
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(0, 0, 0, 0.3)"
            zIndex={100002}
        >
            <CircularProgress size="medium" />
        </Box>,
        document.body,
    );
}
